import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';

class SevenSegNumberField extends Blockly.FieldTextInput {
    override initView() {
        super.initView();
        const t = (this as any).textElement_ as SVGTextElement | undefined;
        t?.classList.add('blocklyNumberFieldText');
    }

    protected override render_() {
        super.render_();
        const block = this.getSourceBlock() as Blockly.BlockSvg | null;
        if (!block) return;
        const ws = block.workspace as Blockly.WorkspaceSvg;
        if (ws?.isFlyout) {
            requestAnimationFrame(() => {
                (this as any).updateSize_?.();
                block.render();
            });
        }
    }

    protected override showEditor_() {
        super.showEditor_();
        requestAnimationFrame(() => {
            const htmlInput = document.querySelector('.blocklyHtmlInput') as HTMLInputElement | null;
            if (htmlInput) {
                htmlInput.style.fontFamily = 'Cantarell, sans-serif';
                htmlInput.style.fontWeight = '600';
                htmlInput.setAttribute('inputmode', 'numeric');
                htmlInput.maxLength = 10;

                const widgetDiv = htmlInput.closest('.blocklyWidgetDiv') as HTMLElement | null;
                if (widgetDiv) {
                    const current = parseFloat(widgetDiv.style.width || '0');
                    widgetDiv.style.width = `${current + 4}px`;

                    const fieldRect = (this as any).textElement_?.getBoundingClientRect();
                    const divRect = widgetDiv.getBoundingClientRect();
                    if (fieldRect) {
                        const fieldCenterX = fieldRect.left + fieldRect.width / 2;
                        const divCenterX = divRect.left + divRect.width / 2;
                        const currentLeft = parseFloat(widgetDiv.style.left || '0');
                        widgetDiv.style.left = `${currentLeft + (fieldCenterX - divCenterX)}px`;
                    }
                }
            }
        });
    }
}

function validator(value: string): string | null {
    const num = parseInt(value, 10);
    if (isNaN(num)) return null;
    if (num < -999 || num > 9999) return null;
    return String(num);
}

defineBlock({
    type: 'number_seven_seg',
    colour: '',
    tooltip: '-999〜9999の整数',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'NUM',
                    instance: () => new SevenSegNumberField('2015', validator),
                },
            ],
        },
    ],
});
